<template>
  <section>
    <div class="items">
      <div class="exit" @click="hideMultiItems()">+</div>
      <div v-for="(event, eventIndex) in this.events" :key="eventIndex">
        <MultiItem :event="event" :events="events" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import MultiItem from "@/components/calendar/MultiItem";

export default {
  props: ["events", "value"],

  components: {
    MultiItem,
  },

  data: () => ({}),

  mounted() {},

  computed: {
    ...mapState("calendar", ["showMulti"]),
    ...mapState("calendar", ["isAddingEvent"]),
  },

  methods: {
    hideMultiItems() {
      this.$store.commit("calendar/setShowMulti", false);
      this.value.show = false;
    },
  },
};
</script>

<style scoped>
p {
  color: black;
  font-size: 12px;
}
.items {
  margin-top: 20px;
}
.exit {
  position: absolute;
  top: -5px;
  right: 5px;
  font-size: 20px;
  width: 10px;
  transform: rotate(45deg);
  align-self: center;
  border-radius: 20vw;
  color: black;
  cursor: pointer;
}
</style>
